// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1Kd7C","emails":"CreateEditClinics_emails__MtkEq","emailTagLabel":"CreateEditClinics_emailTagLabel__3ZaSZ"};